export default {"src":"/_next/static/media/gavel_64.c3994765.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};